<div class="container">
  <div id="cuadro" class="d-flex justify-content-center h-100">
    <div class="card">
      <div class="card-header">
        <h3>Iniciar Sesión</h3>
      </div>
      <div class="card-body">
        <form [formGroup]="myForm" (ngSubmit)="onSubmit()">
          <div class="input-group form-group">

            <input
            id="testCorreo"
			  [class.is-invalid]="myForm.get('carnet').touched && myForm.get('carnet').invalid"
              type="carnet"
              class="form-control"
              placeholder="carnet"
              formControlName="carnet"
              autofocus
            />
          </div>
          <div class="input-group form-group">

            <input
            id="testPassword"
			  [class.is-invalid]="myForm.get('userPass').touched && myForm.get('userPass').invalid"
              type="password"
              class="form-control"
              placeholder="contraseña"
              formControlName="userPass"
            />

          </div>
          <div class="form-group">
            <input
              id="testButton"
              type="submit"
              value="Login"
              class=""
            />
          </div>
          <a href="/registro">Registrarse</a>
          <br>
          <a   (click)="alertconInfo()"  style="color:rgb(44, 90, 241);" >¿Olvidaste tu contraseña?</a>

        </form>
        <div *ngIf="credentialsInvalid" class="alert alert-danger" role="alert" id="alertaLogin">
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <strong>Error</strong><span id="testMensaje">{{this.messageError}}</span>
        </div>
        <button mat-button (click)="encuestaslibres()">Encuestas libres</button>
      </div>
    </div>

    </div>
</div>

